var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box-header-wrapper",class:{
    'show-line': !_vm.$slots.right && !_setup.props.hideLine,
  }},[_c('div',{staticClass:"box-header-title"},[_vm._v(" "+_vm._s(_setup.props.title)+" ")]),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }